import { fetchApi } from '@/config/axiosSetting.ts';
import {
  GetDamagedVehicleCorrectiveImageTabsResponceType,
  GetDamagedVehicleCorrectiveImageTabsType,
} from '@/modules/adjusterReportModules/IncidentParticipants/queries/getDamagedVehicleCorrectiveImageTabs/getDamagedVehicleCorrectiveImageTabs.type';

export const getInitialVisitCorrectiveImageTabsFunction = (
  params?: Omit<GetDamagedVehicleCorrectiveImageTabsType, 'damaged_id'>,
): Promise<GetDamagedVehicleCorrectiveImageTabsResponceType> =>
  fetchApi({
    url: `/initial/reports/${params?.id}/images/corrective/entry_tabs/`,
  });
